/* eslint-disable */
// 引入vue
import Vue from 'vue';
// 引入vue-router
import VueRouter from 'vue-router';
// 第三方库需要use一下才能用
// import layer from 'vue-layer'
// Vue.use(Layer)

// Vue.prototype.Layer = Layer;

// Vue.prototype.$layer = layer(Vue)
Vue.use(VueRouter)
// 引用page1页面 
// import index from './components/index/index.vue';

import header from './components/common/header'
import footer from './components/common/footer'

import user_header from './components/common/user_header'
import user_footer from './components/common/user_footer'

// import product from './components/index/product.vue';

// 引用page2页面 

// 定义routes路由的集合，数组类型
// const routes=[
//     //单个路由均为对象类型，path代表的是路径，component代表组件
    
//     {path:"",component:index},
//     {path:"/",component:index},
//     {path:'/index',component:index},
//     {path:"/about",component:about},
//     {path:"/job",component:job},
//     {path:"/news",component:news},
//     {path:"/service",component:service,
//         children:[            
//             {
//                 path:"/",
//                 component:service
//             },
//             {
//                 path:"/service/tracking",
//                 component:tracking
//             }
//         ]
//     },
//     {path:"/product",component:product},
   
    
// ]

const routes = [    
    

    // {
    //     path: '/',
    //     name:'index',
    //     components:{
    //         default : resolve =>  require(['@/components/index/index'],resolve),
    //         header : header,
    //         footer : footer
    //     },
    //     meta:{
    //         isLogin:false,
    //         title:"速購速遞"
    //     }
    // },
    {
        path: '/index',
        components:{
            default : resolve =>  require(['@/components/index/index'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"速購速遞"
        }
    },    
    {        
        path: '/',
        name:'login',
        component: resolve =>  require(['@/components/index/login'],resolve),
        children: [            
            {   
                path : '/',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/login_login'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"會員登錄"
                }
            },
            {
                path: '/login/register',
                component: resolve =>  require(['@/components/index/login_register'],resolve),
                meta:{
                    isLogin:false,
                    title:"會員註冊"
                }
            },
        ],
        meta:{
            isLogin:false,
            title:"會員登錄"
        }
    },
    {
        path: '/job',
        components: {
            default : resolve =>  require(['@/components/index/job'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"商家合作"
        }
    },
    {
        path: '/product',
        components: {
            default : resolve =>  require(['@/components/index/product'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"產品介紹"
        }
    },
    {
        path: '/service',
        components: {
            default : resolve =>  require(['@/components/index/service'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"服務中心"
        }
    },
    {
        path: '/news',
        components: {
            default : resolve =>  require(['@/components/index/news'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"新聞列表"
        }
    },
    {
        path: '/newsshow',
        name:'newsshow',
        components: {
            default: resolve =>  require(['@/views/index/newsshow'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"新聞詳情"
        }
    },
    {
        path: '/about',
        components: {
            default : resolve =>  require(['@/components/index/about'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"關於我們"
        }
    },
    {
        path: '/tracking',
        name:'tracking',
        components: {
            default : resolve =>  require(['@/components/index/tracking'],resolve),
            header : header,
            footer : footer
        },
        meta:{
            isLogin:false,
            title:"運單追蹤"
        }
    },
    {        
        path: '/member',
        name:'member',
        components: {
            default : resolve =>  require(['@/components/index/member'],resolve),
            header : user_header,
            footer : user_footer
        },
        children: [            
            {   
                path : '/',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/indexme'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"会员首页"
                }
            },
            {   
                path : '/indent',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/indent'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"我的订单"
                }
            },
            {   
                path : '/payment',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/payment'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"待付款"
                }
            },
            {   
                path : '/address',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/address'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"地址管理"
                }
            },
            {   
                path : '/coupon',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/coupon'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"優惠券"
                }
            },
            {   
                path : '/freighTime',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/freighTime'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"运费时效"
                }
            },
            {   
                path : '/onlineStore',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/onlineStore'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"网店查询"
                }
            },
            {   
                path : '/Guest',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/Guest'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"我的客服"
                }
            },
            {   
                path : '/placeOrder',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/placeOrder'],resolve),
                },
                meta:{
                    keepAlive: true, //此组件需要被缓存
                    isLogin:false,
                    title:"立即下單"
                }
            },
            {   
                path : '/amend',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/amend'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"个人中心"
                }
            },
            {   
                path : '/announcement',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/announcement'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"最新公告"
                }
            },
            {   
                path : '/Details',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/Details'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"綫路詳情"
                }
            },
            {   
                path : '/wallet',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/wallet'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"錢包"
                }
            },
            {   
                path : '/recharge',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/recharge'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"充值"
                }
            },
            {   
                path : '/Turning',
                // 当匹配到 /foo 时，这个组件会被渲染到 Foo 组件的 <router-view> 中。
                // 为了简便，这里使用了一个组件的定义
                components: {
                    default : resolve =>  require(['@/components/index/Turning'],resolve),
                },
                meta:{
                    isLogin:false,
                    title:"中转"
                }
            },
            // {
            //     path: '/login/register',
            //     component: resolve =>  require(['@/components/index/login_register'],resolve),
            //     meta:{
            //         isLogin:false,
            //         title:"會員註冊"
            //     }
            // },
        ],
    },
    {        
        path: '/payment',
        name:'payment',
        components: {
            default : resolve =>  require(['@/components/index/payment'],resolve),
            header : user_header,
            footer : user_footer
        },
        meta:{
            isLogin:false,
            title:"代付款"
        }
    },
    {        
        path: '/storereport',
        name:'storereport',
        components: {
            default : resolve =>  require(['@/components/index/storereport'],resolve),
            header : user_header,
            footer : user_footer
        },
        meta:{
            isLogin:true,
            title:"報表下載-會員中心"
        }
        
    },       
       
      
]

//  实例化VueRouter并将routes添加进去
const router=new VueRouter({
//  ES6简写，等于routes：routes
    routes,mode: 'history', // hash  history
    base: '/user',
})

//  抛出这个这个实例对象方便外部读取以及访问
export default router



// WEBPACK FOOTER //
// ./src/router.js